import {
  JsonToBoolean,
  JsonToDouble,
  JsonToInt32,
  JsonToInt64,
  JsonToString,
  JsonToList,
  ArrayToJson,
  JsonToMap,
  MapToJson,
} from '../Helper/Converter';
export class Reward {
  get descriptor() {
    return Reward.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasValue = false;
    this._value = null;
    this._hasStock = false;
    this._stock = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasValue) return false;
    if (this._hasStock) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof Reward) {
      return value;
    }
    return Reward.fromJson(value);
  }
  static fromJson(json) {
    const result = new Reward();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.value != null) {
      result._hasValue = true;
      result._value = JsonToInt32.fromJson(json.value);
    }
    if (json.stock != null) {
      result._hasStock = true;
      result._stock = JsonToInt32.fromJson(json.stock);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasValue) {
      result.value = JsonToInt32.toJson(this._value);
    }
    if (this._hasStock) {
      result.stock = JsonToInt32.toJson(this._stock);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {number}
   */
  get value() {
    return this._hasValue ? this._value : JsonToInt32.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  /**
   * @returns {number}
   */
  get stock() {
    return this._hasStock ? this._stock : JsonToInt32.default;
  }
  get hasStock() {
    return this._hasStock;
  }
  setStock(path, value) {
    return {type: 'SET', path: path.concat(['stock']), value};
  }
  deleteStock(path) {
    return {type: 'DELETE', path: path.concat(['stock'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Reward(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new Reward(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Reward(this);
              copy._hasValue = true;
              copy._value = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new Reward(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "stock": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Reward(this);
              copy._hasStock = true;
              copy._stock = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasStock) {
                return this;
              }
              const copy = new Reward(this);
              copy._hasStock = false;
              copy._stock = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {Reward} other
   * @returns {Reward}
   */
  merge(other) {
    const copy = new Reward(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasValue) {
      copy._hasValue = true;
      copy._value = other._value;
    }
    if (other._hasStock) {
      copy._hasStock = true;
      copy._stock = other._stock;
    }
    return copy;
  }
}
Reward.default = new Reward();
class Reward_Builder {
  constructor(value) {
    this._value = new Reward(value);
  }
  build() {
    return new Reward(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
  setStock(value) {
    this._value._hasStock = true;
    this._value._stock = value;
    return this;
  }
  deleteStock() {
    this._value._hasStock = false;
    this._value._stock = null;
    return this;
  }
}
Reward.Builder = Reward_Builder;
class Reward_WithParent {
  /**
   * @param {Reward} value
   * @param {Reward_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return Reward.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (this._cachedValue === undefined) {
      if (this._value.hasValue) {
        this._cachedValue = this._value.value;
      } else {
        this._cachedValue = this._parent ? this._parent.value : this._value.value;
      }
    }
    return this._cachedValue;
  }
  get hasStock() {
    if (this._cachedHasStock === undefined) {
      if (this._value.hasStock) {
        this._cachedHasStock = true;
      } else {
        this._cachedHasStock = this._parent ? this._parent.hasStock : false;
      }
    }
    return this._cachedHasStock;
  }
  get stock() {
    if (this._cachedStock === undefined) {
      if (this._value.hasStock) {
        this._cachedStock = this._value.stock;
      } else {
        this._cachedStock = this._parent ? this._parent.stock : this._value.stock;
      }
    }
    return this._cachedStock;
  }
  update(current, parent) {
    const result = new Reward_WithParent(current, parent);
    return result;
  }
}
Reward_WithParent.default = new Reward_WithParent(Reward.default, null);
Reward.WithParent = Reward_WithParent;
class Reward_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 2,
        protoType: 5,
        protoName: "value",
        type: JsonToInt32,
        options: {
          comments: "The additive value",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get stock() {
    if (!this._stock) {
      this._stock = {
        name: "stock",
        Name: "Stock",
        number: 3,
        protoType: 5,
        protoName: "stock",
        type: JsonToInt32,
        options: {
          comments: "How much in total this item has",
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._stock;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.value,
        this.stock,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForKey",
        Name: "DummyOneofForKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForValue",
        Name: "DummyOneofForValue",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForStock",
        Name: "DummyOneofForStock",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
Reward.descriptor = new Reward_Descriptor();
class RewardPattern_RewardPatternItem {
  get descriptor() {
    return RewardPattern_RewardPatternItem.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasItemKey = false;
    this._itemKey = null;
    this._hasAmountMin = false;
    this._amountMin = null;
    this._hasAmountMax = false;
    this._amountMax = null;
    this._hasChance = false;
    this._chance = null;
  }
  isEmpty() {
    if (this._hasItemKey) return false;
    if (this._hasAmountMin) return false;
    if (this._hasAmountMax) return false;
    if (this._hasChance) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof RewardPattern_RewardPatternItem) {
      return value;
    }
    return RewardPattern_RewardPatternItem.fromJson(value);
  }
  static fromJson(json) {
    const result = new RewardPattern_RewardPatternItem();
    if (json.itemKey != null) {
      result._hasItemKey = true;
      result._itemKey = JsonToString.fromJson(json.itemKey);
    }
    if (json.amountMin != null) {
      result._hasAmountMin = true;
      result._amountMin = JsonToInt32.fromJson(json.amountMin);
    }
    if (json.amountMax != null) {
      result._hasAmountMax = true;
      result._amountMax = JsonToInt32.fromJson(json.amountMax);
    }
    if (json.chance != null) {
      result._hasChance = true;
      result._chance = JsonToDouble.fromJson(json.chance);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasItemKey) {
      result.itemKey = JsonToString.toJson(this._itemKey);
    }
    if (this._hasAmountMin) {
      result.amountMin = JsonToInt32.toJson(this._amountMin);
    }
    if (this._hasAmountMax) {
      result.amountMax = JsonToInt32.toJson(this._amountMax);
    }
    if (this._hasChance) {
      result.chance = JsonToDouble.toJson(this._chance);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get itemKey() {
    return this._hasItemKey ? this._itemKey : JsonToString.default;
  }
  get hasItemKey() {
    return this._hasItemKey;
  }
  setItemKey(path, value) {
    return {type: 'SET', path: path.concat(['itemKey']), value};
  }
  deleteItemKey(path) {
    return {type: 'DELETE', path: path.concat(['itemKey'])};
  }
  /**
   * @returns {number}
   */
  get amountMin() {
    return this._hasAmountMin ? this._amountMin : JsonToInt32.default;
  }
  get hasAmountMin() {
    return this._hasAmountMin;
  }
  setAmountMin(path, value) {
    return {type: 'SET', path: path.concat(['amountMin']), value};
  }
  deleteAmountMin(path) {
    return {type: 'DELETE', path: path.concat(['amountMin'])};
  }
  /**
   * @returns {number}
   */
  get amountMax() {
    return this._hasAmountMax ? this._amountMax : JsonToInt32.default;
  }
  get hasAmountMax() {
    return this._hasAmountMax;
  }
  setAmountMax(path, value) {
    return {type: 'SET', path: path.concat(['amountMax']), value};
  }
  deleteAmountMax(path) {
    return {type: 'DELETE', path: path.concat(['amountMax'])};
  }
  /**
   * @returns {number}
   */
  get chance() {
    return this._hasChance ? this._chance : JsonToDouble.default;
  }
  get hasChance() {
    return this._hasChance;
  }
  setChance(path, value) {
    return {type: 'SET', path: path.concat(['chance']), value};
  }
  deleteChance(path) {
    return {type: 'DELETE', path: path.concat(['chance'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "itemKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new RewardPattern_RewardPatternItem(this);
              copy._hasItemKey = true;
              copy._itemKey = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasItemKey) {
                return this;
              }
              const copy = new RewardPattern_RewardPatternItem(this);
              copy._hasItemKey = false;
              copy._itemKey = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "amountMin": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new RewardPattern_RewardPatternItem(this);
              copy._hasAmountMin = true;
              copy._amountMin = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAmountMin) {
                return this;
              }
              const copy = new RewardPattern_RewardPatternItem(this);
              copy._hasAmountMin = false;
              copy._amountMin = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "amountMax": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new RewardPattern_RewardPatternItem(this);
              copy._hasAmountMax = true;
              copy._amountMax = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAmountMax) {
                return this;
              }
              const copy = new RewardPattern_RewardPatternItem(this);
              copy._hasAmountMax = false;
              copy._amountMax = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "chance": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new RewardPattern_RewardPatternItem(this);
              copy._hasChance = true;
              copy._chance = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasChance) {
                return this;
              }
              const copy = new RewardPattern_RewardPatternItem(this);
              copy._hasChance = false;
              copy._chance = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {RewardPattern_RewardPatternItem} other
   * @returns {RewardPattern_RewardPatternItem}
   */
  merge(other) {
    const copy = new RewardPattern_RewardPatternItem(this);
    if (other._hasItemKey) {
      copy._hasItemKey = true;
      copy._itemKey = other._itemKey;
    }
    if (other._hasAmountMin) {
      copy._hasAmountMin = true;
      copy._amountMin = other._amountMin;
    }
    if (other._hasAmountMax) {
      copy._hasAmountMax = true;
      copy._amountMax = other._amountMax;
    }
    if (other._hasChance) {
      copy._hasChance = true;
      copy._chance = other._chance;
    }
    return copy;
  }
}
RewardPattern_RewardPatternItem.default = new RewardPattern_RewardPatternItem();
class RewardPattern_RewardPatternItem_Builder {
  constructor(value) {
    this._value = new RewardPattern_RewardPatternItem(value);
  }
  build() {
    return new RewardPattern_RewardPatternItem(this._value);
  }
  setItemKey(value) {
    this._value._hasItemKey = true;
    this._value._itemKey = value;
    return this;
  }
  deleteItemKey() {
    this._value._hasItemKey = false;
    this._value._itemKey = null;
    return this;
  }
  setAmountMin(value) {
    this._value._hasAmountMin = true;
    this._value._amountMin = value;
    return this;
  }
  deleteAmountMin() {
    this._value._hasAmountMin = false;
    this._value._amountMin = null;
    return this;
  }
  setAmountMax(value) {
    this._value._hasAmountMax = true;
    this._value._amountMax = value;
    return this;
  }
  deleteAmountMax() {
    this._value._hasAmountMax = false;
    this._value._amountMax = null;
    return this;
  }
  setChance(value) {
    this._value._hasChance = true;
    this._value._chance = value;
    return this;
  }
  deleteChance() {
    this._value._hasChance = false;
    this._value._chance = null;
    return this;
  }
}
RewardPattern_RewardPatternItem.Builder = RewardPattern_RewardPatternItem_Builder;
class RewardPattern_RewardPatternItem_WithParent {
  /**
   * @param {RewardPattern_RewardPatternItem} value
   * @param {RewardPattern_RewardPatternItem_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return RewardPattern_RewardPatternItem.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasItemKey() {
    if (this._cachedHasItemKey === undefined) {
      if (this._value.hasItemKey) {
        this._cachedHasItemKey = true;
      } else {
        this._cachedHasItemKey = this._parent ? this._parent.hasItemKey : false;
      }
    }
    return this._cachedHasItemKey;
  }
  get itemKey() {
    if (this._cachedItemKey === undefined) {
      if (this._value.hasItemKey) {
        this._cachedItemKey = this._value.itemKey;
      } else {
        this._cachedItemKey = this._parent ? this._parent.itemKey : this._value.itemKey;
      }
    }
    return this._cachedItemKey;
  }
  get hasAmountMin() {
    if (this._cachedHasAmountMin === undefined) {
      if (this._value.hasAmountMin) {
        this._cachedHasAmountMin = true;
      } else {
        this._cachedHasAmountMin = this._parent ? this._parent.hasAmountMin : false;
      }
    }
    return this._cachedHasAmountMin;
  }
  get amountMin() {
    if (this._cachedAmountMin === undefined) {
      if (this._value.hasAmountMin) {
        this._cachedAmountMin = this._value.amountMin;
      } else {
        this._cachedAmountMin = this._parent ? this._parent.amountMin : this._value.amountMin;
      }
    }
    return this._cachedAmountMin;
  }
  get hasAmountMax() {
    if (this._cachedHasAmountMax === undefined) {
      if (this._value.hasAmountMax) {
        this._cachedHasAmountMax = true;
      } else {
        this._cachedHasAmountMax = this._parent ? this._parent.hasAmountMax : false;
      }
    }
    return this._cachedHasAmountMax;
  }
  get amountMax() {
    if (this._cachedAmountMax === undefined) {
      if (this._value.hasAmountMax) {
        this._cachedAmountMax = this._value.amountMax;
      } else {
        this._cachedAmountMax = this._parent ? this._parent.amountMax : this._value.amountMax;
      }
    }
    return this._cachedAmountMax;
  }
  get hasChance() {
    if (this._cachedHasChance === undefined) {
      if (this._value.hasChance) {
        this._cachedHasChance = true;
      } else {
        this._cachedHasChance = this._parent ? this._parent.hasChance : false;
      }
    }
    return this._cachedHasChance;
  }
  get chance() {
    if (this._cachedChance === undefined) {
      if (this._value.hasChance) {
        this._cachedChance = this._value.chance;
      } else {
        this._cachedChance = this._parent ? this._parent.chance : this._value.chance;
      }
    }
    return this._cachedChance;
  }
  update(current, parent) {
    const result = new RewardPattern_RewardPatternItem_WithParent(current, parent);
    return result;
  }
}
RewardPattern_RewardPatternItem_WithParent.default = new RewardPattern_RewardPatternItem_WithParent(RewardPattern_RewardPatternItem.default, null);
RewardPattern_RewardPatternItem.WithParent = RewardPattern_RewardPatternItem_WithParent;
class RewardPattern_RewardPatternItem_Descriptor {
  get itemKey() {
    if (!this._itemKey) {
      this._itemKey = {
        name: "itemKey",
        Name: "ItemKey",
        number: 1,
        protoType: 9,
        protoName: "item_key",
        type: JsonToString,
        options: {
          valueDropdown: "RewardItemKeyList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._itemKey;
  }
  get amountMin() {
    if (!this._amountMin) {
      this._amountMin = {
        name: "amountMin",
        Name: "AmountMin",
        number: 2,
        protoType: 5,
        protoName: "amount_min",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._amountMin;
  }
  get amountMax() {
    if (!this._amountMax) {
      this._amountMax = {
        name: "amountMax",
        Name: "AmountMax",
        number: 3,
        protoType: 5,
        protoName: "amount_max",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._amountMax;
  }
  get chance() {
    if (!this._chance) {
      this._chance = {
        name: "chance",
        Name: "Chance",
        number: 4,
        protoType: 1,
        protoName: "chance",
        type: JsonToDouble,
        options: {
          comments: "For slots, this is treated as weight For items, this is independent chance",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._chance;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.itemKey,
        this.amountMin,
        this.amountMax,
        this.chance,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForItemKey",
        Name: "DummyOneofForItemKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAmountMin",
        Name: "DummyOneofForAmountMin",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAmountMax",
        Name: "DummyOneofForAmountMax",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForChance",
        Name: "DummyOneofForChance",
        fields: [
          this.fields[3],
        ],
      });
    }
    return this._oneofs;
  }
}
RewardPattern_RewardPatternItem.descriptor = new RewardPattern_RewardPatternItem_Descriptor();
class RewardPattern_RewardPatternSlot {
  get descriptor() {
    return RewardPattern_RewardPatternSlot.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._slotItems = [];
  }
  isEmpty() {
    if (this._slotItems.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof RewardPattern_RewardPatternSlot) {
      return value;
    }
    return RewardPattern_RewardPatternSlot.fromJson(value);
  }
  static fromJson(json) {
    const result = new RewardPattern_RewardPatternSlot();
    result._slotItems = JsonToList(json.slotItems, RewardPattern_RewardPatternItem);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._slotItems.length > 0) {
      result.slotItems = ArrayToJson(this._slotItems, RewardPattern_RewardPatternItem);
    }
    return result;
  }
  /**
   * @returns {RewardPattern_RewardPatternItem[]}
   */
  get slotItems() {
    return this._slotItems;
  }
  addSlotItems(path, value) {
    return {type: 'ADD', path: path.concat(['slotItems']), value: value.toJson()};
  }
  setSlotItems(path, value) {
    return {type: 'SET', path: path.concat(['slotItems']), value: ArrayToJson(value, RewardPattern_RewardPatternItem)};
  }
  setSlotItemsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['slotItems', key]), value: value.toJson()};
  }
  deleteSlotItems(path) {
    return {type: 'DELETE', path: path.concat(['slotItems'])};
  }
  deleteSlotItemsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['slotItems', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "slotItems": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new RewardPattern_RewardPatternSlot(this);
              copy._slotItems = [];        for (let i of value) {
                copy._slotItems.push(RewardPattern_RewardPatternItem.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new RewardPattern_RewardPatternSlot(this);
              copy._slotItems = copy._slotItems.concat([RewardPattern_RewardPatternItem.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._slotItems.length === 0) {
                return this;
              }
              const copy = new RewardPattern_RewardPatternSlot(this);
              copy._slotItems = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._slotItems.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new RewardPattern_RewardPatternSlot(this);
              copy._slotItems = copy._slotItems.slice();
              copy._slotItems[path[1]] = RewardPattern_RewardPatternItem.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new RewardPattern_RewardPatternSlot(this);
              copy._slotItems = copy._slotItems.slice(0, path[1]).concat(copy._slotItems.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._slotItems.length) {
            return this;
          }
          const oldValue = this._slotItems[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new RewardPattern_RewardPatternSlot(this);
          copy._slotItems = copy._slotItems.slice();
          copy._slotItems[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {RewardPattern_RewardPatternSlot} other
   * @returns {RewardPattern_RewardPatternSlot}
   */
  merge(other) {
    const copy = new RewardPattern_RewardPatternSlot(this);
    copy._slotItems = this._slotItems.concat(other._slotItems);
    return copy;
  }
}
RewardPattern_RewardPatternSlot.default = new RewardPattern_RewardPatternSlot();
class RewardPattern_RewardPatternSlot_Builder {
  constructor(value) {
    this._value = new RewardPattern_RewardPatternSlot(value);
  }
  build() {
    return new RewardPattern_RewardPatternSlot(this._value);
  }
  addAllSlotItems(values) {
    this._value._slotItems = this._value._slotItems.concat(values);
    return this;
  }
  addSlotItems(value) {
    this._value._slotItems = this._value._slotItems.concat([value]);
    return this;
  }
  setSlotItems(index, value) {
    this._value._slotItems = this._value._slotItems.concat();
    this._value._slotItems[index] = value;
    return this;
  }
  clearSlotItems() {
    this._value._slotItems = [];
    return this;
  }
}
RewardPattern_RewardPatternSlot.Builder = RewardPattern_RewardPatternSlot_Builder;
class RewardPattern_RewardPatternSlot_WithParent {
  /**
   * @param {RewardPattern_RewardPatternSlot} value
   * @param {RewardPattern_RewardPatternSlot_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return RewardPattern_RewardPatternSlot.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfSlotItems() {
    if (!this._selfSlotItems) {
      this._selfSlotItems = [];
      for (let i of this._value.slotItems) {
        this._selfSlotItems.push(new RewardPattern_RewardPatternItem.WithParent(i, null));
      }
    }
    return this._selfSlotItems;
  }
  get inherentSlotItems() {
    if (!this._inherentSlotItems) {
      this._inherentSlotItems = this._parent ? this._parent.slotItems : [];
    }
    return this._inherentSlotItems;
  }
  get slotItems() {
    if (!this._allSlotItems) {
      this._allSlotItems = this._parent ? this._parent.slotItems.concat(this.selfSlotItems) : this.selfSlotItems;
    }
    return this._allSlotItems;
  }
  update(current, parent) {
    const result = new RewardPattern_RewardPatternSlot_WithParent(current, parent);
    if (this._selfSlotItems) {
      if (this._value.slotItems === current.slotItems) {
        result._selfSlotItems = this._selfSlotItems;
      } else {
        result._selfSlotItems = [];
        for (let i = 0; i < current.slotItems.length; i++) {
          const oldValue = this._value.slotItems[i];
          if (oldValue) {
            const oldCache = this._selfSlotItems[i];
            if (oldValue === current.slotItems[i]) {
              result._selfSlotItems[i] = oldCache;
            } else {
              result._selfSlotItems[i] = oldCache.update(current.slotItems[i], null);
            }
          } else {
            result._selfSlotItems[i] = new RewardPattern_RewardPatternItem.WithParent(current.slotItems[i], null);
          }
        }
      }
    }
    return result;
  }
}
RewardPattern_RewardPatternSlot_WithParent.default = new RewardPattern_RewardPatternSlot_WithParent(RewardPattern_RewardPatternSlot.default, null);
RewardPattern_RewardPatternSlot.WithParent = RewardPattern_RewardPatternSlot_WithParent;
class RewardPattern_RewardPatternSlot_Descriptor {
  get slotItems() {
    if (!this._slotItems) {
      this._slotItems = {
        name: "slotItems",
        Name: "SlotItems",
        number: 2,
        protoType: 11,
        protoName: "slot_items",
        type: RewardPattern_RewardPatternItem,
        isRepeated: true,
        options: {
          comments: "The chance field is treated as weight in this group",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._slotItems;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.slotItems,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
RewardPattern_RewardPatternSlot.descriptor = new RewardPattern_RewardPatternSlot_Descriptor();
class RewardPattern_RegularPattern {
  get descriptor() {
    return RewardPattern_RegularPattern.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
  }
  isEmpty() {
    return true;
  }
  static fromAny(value) {
    if (value instanceof RewardPattern_RegularPattern) {
      return value;
    }
    return RewardPattern_RegularPattern.fromJson(value);
  }
  static fromJson(json) {
    const result = new RewardPattern_RegularPattern();
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    return result;
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      default:
        return this;
    }
  }
  /**
   * @param {RewardPattern_RegularPattern} other
   * @returns {RewardPattern_RegularPattern}
   */
  merge(other) {
    const copy = new RewardPattern_RegularPattern(this);
    return copy;
  }
}
RewardPattern_RegularPattern.default = new RewardPattern_RegularPattern();
class RewardPattern_RegularPattern_Builder {
  constructor(value) {
    this._value = new RewardPattern_RegularPattern(value);
  }
  build() {
    return new RewardPattern_RegularPattern(this._value);
  }
}
RewardPattern_RegularPattern.Builder = RewardPattern_RegularPattern_Builder;
class RewardPattern_RegularPattern_WithParent {
  /**
   * @param {RewardPattern_RegularPattern} value
   * @param {RewardPattern_RegularPattern_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return RewardPattern_RegularPattern.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  update(current, parent) {
    const result = new RewardPattern_RegularPattern_WithParent(current, parent);
    return result;
  }
}
RewardPattern_RegularPattern_WithParent.default = new RewardPattern_RegularPattern_WithParent(RewardPattern_RegularPattern.default, null);
RewardPattern_RegularPattern.WithParent = RewardPattern_RegularPattern_WithParent;
class RewardPattern_RegularPattern_Descriptor {
  get fields() {
    if (!this._fields) {
      this._fields = [
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
RewardPattern_RegularPattern.descriptor = new RewardPattern_RegularPattern_Descriptor();
class RewardPattern_DungeonPattern {
  get descriptor() {
    return RewardPattern_DungeonPattern.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasFeatured = false;
    this._featured = null;
  }
  isEmpty() {
    if (this._hasFeatured) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof RewardPattern_DungeonPattern) {
      return value;
    }
    return RewardPattern_DungeonPattern.fromJson(value);
  }
  static fromJson(json) {
    const result = new RewardPattern_DungeonPattern();
    if (json.featured != null) {
      result._hasFeatured = true;
      result._featured = JsonToBoolean.fromJson(json.featured);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasFeatured) {
      result.featured = JsonToBoolean.toJson(this._featured);
    }
    return result;
  }
  /**
   * @returns {boolean}
   */
  get featured() {
    return this._hasFeatured ? this._featured : JsonToBoolean.default;
  }
  get hasFeatured() {
    return this._hasFeatured;
  }
  setFeatured(path, value) {
    return {type: 'SET', path: path.concat(['featured']), value};
  }
  deleteFeatured(path) {
    return {type: 'DELETE', path: path.concat(['featured'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "featured": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new RewardPattern_DungeonPattern(this);
              copy._hasFeatured = true;
              copy._featured = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasFeatured) {
                return this;
              }
              const copy = new RewardPattern_DungeonPattern(this);
              copy._hasFeatured = false;
              copy._featured = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {RewardPattern_DungeonPattern} other
   * @returns {RewardPattern_DungeonPattern}
   */
  merge(other) {
    const copy = new RewardPattern_DungeonPattern(this);
    if (other._hasFeatured) {
      copy._hasFeatured = true;
      copy._featured = other._featured;
    }
    return copy;
  }
}
RewardPattern_DungeonPattern.default = new RewardPattern_DungeonPattern();
class RewardPattern_DungeonPattern_Builder {
  constructor(value) {
    this._value = new RewardPattern_DungeonPattern(value);
  }
  build() {
    return new RewardPattern_DungeonPattern(this._value);
  }
  setFeatured(value) {
    this._value._hasFeatured = true;
    this._value._featured = value;
    return this;
  }
  deleteFeatured() {
    this._value._hasFeatured = false;
    this._value._featured = null;
    return this;
  }
}
RewardPattern_DungeonPattern.Builder = RewardPattern_DungeonPattern_Builder;
class RewardPattern_DungeonPattern_WithParent {
  /**
   * @param {RewardPattern_DungeonPattern} value
   * @param {RewardPattern_DungeonPattern_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return RewardPattern_DungeonPattern.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasFeatured() {
    if (this._cachedHasFeatured === undefined) {
      if (this._value.hasFeatured) {
        this._cachedHasFeatured = true;
      } else {
        this._cachedHasFeatured = this._parent ? this._parent.hasFeatured : false;
      }
    }
    return this._cachedHasFeatured;
  }
  get featured() {
    if (this._cachedFeatured === undefined) {
      if (this._value.hasFeatured) {
        this._cachedFeatured = this._value.featured;
      } else {
        this._cachedFeatured = this._parent ? this._parent.featured : this._value.featured;
      }
    }
    return this._cachedFeatured;
  }
  update(current, parent) {
    const result = new RewardPattern_DungeonPattern_WithParent(current, parent);
    return result;
  }
}
RewardPattern_DungeonPattern_WithParent.default = new RewardPattern_DungeonPattern_WithParent(RewardPattern_DungeonPattern.default, null);
RewardPattern_DungeonPattern.WithParent = RewardPattern_DungeonPattern_WithParent;
class RewardPattern_DungeonPattern_Descriptor {
  get featured() {
    if (!this._featured) {
      this._featured = {
        name: "featured",
        Name: "Featured",
        number: 1,
        protoType: 8,
        protoName: "featured",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._featured;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.featured,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForFeatured",
        Name: "DummyOneofForFeatured",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
RewardPattern_DungeonPattern.descriptor = new RewardPattern_DungeonPattern_Descriptor();
class RewardPattern_OccurrencePattern {
  get descriptor() {
    return RewardPattern_OccurrencePattern.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasTimeToOccurOnce = false;
    this._timeToOccurOnce = null;
  }
  isEmpty() {
    if (this._hasTimeToOccurOnce) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof RewardPattern_OccurrencePattern) {
      return value;
    }
    return RewardPattern_OccurrencePattern.fromJson(value);
  }
  static fromJson(json) {
    const result = new RewardPattern_OccurrencePattern();
    if (json.timeToOccurOnce != null) {
      result._hasTimeToOccurOnce = true;
      result._timeToOccurOnce = JsonToInt32.fromJson(json.timeToOccurOnce);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasTimeToOccurOnce) {
      result.timeToOccurOnce = JsonToInt32.toJson(this._timeToOccurOnce);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get timeToOccurOnce() {
    return this._hasTimeToOccurOnce ? this._timeToOccurOnce : JsonToInt32.default;
  }
  get hasTimeToOccurOnce() {
    return this._hasTimeToOccurOnce;
  }
  setTimeToOccurOnce(path, value) {
    return {type: 'SET', path: path.concat(['timeToOccurOnce']), value};
  }
  deleteTimeToOccurOnce(path) {
    return {type: 'DELETE', path: path.concat(['timeToOccurOnce'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "timeToOccurOnce": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new RewardPattern_OccurrencePattern(this);
              copy._hasTimeToOccurOnce = true;
              copy._timeToOccurOnce = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTimeToOccurOnce) {
                return this;
              }
              const copy = new RewardPattern_OccurrencePattern(this);
              copy._hasTimeToOccurOnce = false;
              copy._timeToOccurOnce = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {RewardPattern_OccurrencePattern} other
   * @returns {RewardPattern_OccurrencePattern}
   */
  merge(other) {
    const copy = new RewardPattern_OccurrencePattern(this);
    if (other._hasTimeToOccurOnce) {
      copy._hasTimeToOccurOnce = true;
      copy._timeToOccurOnce = other._timeToOccurOnce;
    }
    return copy;
  }
}
RewardPattern_OccurrencePattern.default = new RewardPattern_OccurrencePattern();
class RewardPattern_OccurrencePattern_Builder {
  constructor(value) {
    this._value = new RewardPattern_OccurrencePattern(value);
  }
  build() {
    return new RewardPattern_OccurrencePattern(this._value);
  }
  setTimeToOccurOnce(value) {
    this._value._hasTimeToOccurOnce = true;
    this._value._timeToOccurOnce = value;
    return this;
  }
  deleteTimeToOccurOnce() {
    this._value._hasTimeToOccurOnce = false;
    this._value._timeToOccurOnce = null;
    return this;
  }
}
RewardPattern_OccurrencePattern.Builder = RewardPattern_OccurrencePattern_Builder;
class RewardPattern_OccurrencePattern_WithParent {
  /**
   * @param {RewardPattern_OccurrencePattern} value
   * @param {RewardPattern_OccurrencePattern_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return RewardPattern_OccurrencePattern.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasTimeToOccurOnce() {
    if (this._cachedHasTimeToOccurOnce === undefined) {
      if (this._value.hasTimeToOccurOnce) {
        this._cachedHasTimeToOccurOnce = true;
      } else {
        this._cachedHasTimeToOccurOnce = this._parent ? this._parent.hasTimeToOccurOnce : false;
      }
    }
    return this._cachedHasTimeToOccurOnce;
  }
  get timeToOccurOnce() {
    if (this._cachedTimeToOccurOnce === undefined) {
      if (this._value.hasTimeToOccurOnce) {
        this._cachedTimeToOccurOnce = this._value.timeToOccurOnce;
      } else {
        this._cachedTimeToOccurOnce = this._parent ? this._parent.timeToOccurOnce : this._value.timeToOccurOnce;
      }
    }
    return this._cachedTimeToOccurOnce;
  }
  update(current, parent) {
    const result = new RewardPattern_OccurrencePattern_WithParent(current, parent);
    return result;
  }
}
RewardPattern_OccurrencePattern_WithParent.default = new RewardPattern_OccurrencePattern_WithParent(RewardPattern_OccurrencePattern.default, null);
RewardPattern_OccurrencePattern.WithParent = RewardPattern_OccurrencePattern_WithParent;
class RewardPattern_OccurrencePattern_Descriptor {
  get timeToOccurOnce() {
    if (!this._timeToOccurOnce) {
      this._timeToOccurOnce = {
        name: "timeToOccurOnce",
        Name: "TimeToOccurOnce",
        number: 1,
        protoType: 5,
        protoName: "time_to_occur_once",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._timeToOccurOnce;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.timeToOccurOnce,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForTimeToOccurOnce",
        Name: "DummyOneofForTimeToOccurOnce",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
RewardPattern_OccurrencePattern.descriptor = new RewardPattern_OccurrencePattern_Descriptor();
class RewardPattern_LevelDependentPattern {
  get descriptor() {
    return RewardPattern_LevelDependentPattern.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasLevelMin = false;
    this._levelMin = null;
    this._hasLevelMax = false;
    this._levelMax = null;
  }
  isEmpty() {
    if (this._hasLevelMin) return false;
    if (this._hasLevelMax) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof RewardPattern_LevelDependentPattern) {
      return value;
    }
    return RewardPattern_LevelDependentPattern.fromJson(value);
  }
  static fromJson(json) {
    const result = new RewardPattern_LevelDependentPattern();
    if (json.levelMin != null) {
      result._hasLevelMin = true;
      result._levelMin = JsonToInt32.fromJson(json.levelMin);
    }
    if (json.levelMax != null) {
      result._hasLevelMax = true;
      result._levelMax = JsonToInt32.fromJson(json.levelMax);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasLevelMin) {
      result.levelMin = JsonToInt32.toJson(this._levelMin);
    }
    if (this._hasLevelMax) {
      result.levelMax = JsonToInt32.toJson(this._levelMax);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get levelMin() {
    return this._hasLevelMin ? this._levelMin : JsonToInt32.default;
  }
  get hasLevelMin() {
    return this._hasLevelMin;
  }
  setLevelMin(path, value) {
    return {type: 'SET', path: path.concat(['levelMin']), value};
  }
  deleteLevelMin(path) {
    return {type: 'DELETE', path: path.concat(['levelMin'])};
  }
  /**
   * @returns {number}
   */
  get levelMax() {
    return this._hasLevelMax ? this._levelMax : JsonToInt32.default;
  }
  get hasLevelMax() {
    return this._hasLevelMax;
  }
  setLevelMax(path, value) {
    return {type: 'SET', path: path.concat(['levelMax']), value};
  }
  deleteLevelMax(path) {
    return {type: 'DELETE', path: path.concat(['levelMax'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "levelMin": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new RewardPattern_LevelDependentPattern(this);
              copy._hasLevelMin = true;
              copy._levelMin = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLevelMin) {
                return this;
              }
              const copy = new RewardPattern_LevelDependentPattern(this);
              copy._hasLevelMin = false;
              copy._levelMin = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "levelMax": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new RewardPattern_LevelDependentPattern(this);
              copy._hasLevelMax = true;
              copy._levelMax = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLevelMax) {
                return this;
              }
              const copy = new RewardPattern_LevelDependentPattern(this);
              copy._hasLevelMax = false;
              copy._levelMax = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {RewardPattern_LevelDependentPattern} other
   * @returns {RewardPattern_LevelDependentPattern}
   */
  merge(other) {
    const copy = new RewardPattern_LevelDependentPattern(this);
    if (other._hasLevelMin) {
      copy._hasLevelMin = true;
      copy._levelMin = other._levelMin;
    }
    if (other._hasLevelMax) {
      copy._hasLevelMax = true;
      copy._levelMax = other._levelMax;
    }
    return copy;
  }
}
RewardPattern_LevelDependentPattern.default = new RewardPattern_LevelDependentPattern();
class RewardPattern_LevelDependentPattern_Builder {
  constructor(value) {
    this._value = new RewardPattern_LevelDependentPattern(value);
  }
  build() {
    return new RewardPattern_LevelDependentPattern(this._value);
  }
  setLevelMin(value) {
    this._value._hasLevelMin = true;
    this._value._levelMin = value;
    return this;
  }
  deleteLevelMin() {
    this._value._hasLevelMin = false;
    this._value._levelMin = null;
    return this;
  }
  setLevelMax(value) {
    this._value._hasLevelMax = true;
    this._value._levelMax = value;
    return this;
  }
  deleteLevelMax() {
    this._value._hasLevelMax = false;
    this._value._levelMax = null;
    return this;
  }
}
RewardPattern_LevelDependentPattern.Builder = RewardPattern_LevelDependentPattern_Builder;
class RewardPattern_LevelDependentPattern_WithParent {
  /**
   * @param {RewardPattern_LevelDependentPattern} value
   * @param {RewardPattern_LevelDependentPattern_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return RewardPattern_LevelDependentPattern.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasLevelMin() {
    if (this._cachedHasLevelMin === undefined) {
      if (this._value.hasLevelMin) {
        this._cachedHasLevelMin = true;
      } else {
        this._cachedHasLevelMin = this._parent ? this._parent.hasLevelMin : false;
      }
    }
    return this._cachedHasLevelMin;
  }
  get levelMin() {
    if (this._cachedLevelMin === undefined) {
      if (this._value.hasLevelMin) {
        this._cachedLevelMin = this._value.levelMin;
      } else {
        this._cachedLevelMin = this._parent ? this._parent.levelMin : this._value.levelMin;
      }
    }
    return this._cachedLevelMin;
  }
  get hasLevelMax() {
    if (this._cachedHasLevelMax === undefined) {
      if (this._value.hasLevelMax) {
        this._cachedHasLevelMax = true;
      } else {
        this._cachedHasLevelMax = this._parent ? this._parent.hasLevelMax : false;
      }
    }
    return this._cachedHasLevelMax;
  }
  get levelMax() {
    if (this._cachedLevelMax === undefined) {
      if (this._value.hasLevelMax) {
        this._cachedLevelMax = this._value.levelMax;
      } else {
        this._cachedLevelMax = this._parent ? this._parent.levelMax : this._value.levelMax;
      }
    }
    return this._cachedLevelMax;
  }
  update(current, parent) {
    const result = new RewardPattern_LevelDependentPattern_WithParent(current, parent);
    return result;
  }
}
RewardPattern_LevelDependentPattern_WithParent.default = new RewardPattern_LevelDependentPattern_WithParent(RewardPattern_LevelDependentPattern.default, null);
RewardPattern_LevelDependentPattern.WithParent = RewardPattern_LevelDependentPattern_WithParent;
class RewardPattern_LevelDependentPattern_Descriptor {
  get levelMin() {
    if (!this._levelMin) {
      this._levelMin = {
        name: "levelMin",
        Name: "LevelMin",
        number: 2,
        protoType: 5,
        protoName: "level_min",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._levelMin;
  }
  get levelMax() {
    if (!this._levelMax) {
      this._levelMax = {
        name: "levelMax",
        Name: "LevelMax",
        number: 3,
        protoType: 5,
        protoName: "level_max",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._levelMax;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.levelMin,
        this.levelMax,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForLevelMin",
        Name: "DummyOneofForLevelMin",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForLevelMax",
        Name: "DummyOneofForLevelMax",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
RewardPattern_LevelDependentPattern.descriptor = new RewardPattern_LevelDependentPattern_Descriptor();
export class RewardPattern {
  get descriptor() {
    return RewardPattern.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasPatternName = false;
    this._patternName = null;
    this._items = [];
    this._slots = [];
    this._patternTypeCase = 0;
    this._patternTypeValue = null;
  }
  isEmpty() {
    if (this._hasPatternName) return false;
    if (this._items.length > 0) return false;
    if (this._slots.length > 0) return false;
    if (this._patternTypeCase !== 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof RewardPattern) {
      return value;
    }
    return RewardPattern.fromJson(value);
  }
  static fromJson(json) {
    const result = new RewardPattern();
    if (json.patternName != null) {
      result._hasPatternName = true;
      result._patternName = JsonToString.fromJson(json.patternName);
    }
    result._items = JsonToList(json.items, RewardPattern_RewardPatternItem);
    result._slots = JsonToList(json.slots, RewardPattern_RewardPatternSlot);
    if (json.regularPattern != null) {
      result._patternTypeCase = 101;
      result._patternTypeValue = RewardPattern_RegularPattern.fromJson(json.regularPattern);
    }
    if (json.dungeonPattern != null) {
      result._patternTypeCase = 102;
      result._patternTypeValue = RewardPattern_DungeonPattern.fromJson(json.dungeonPattern);
    }
    if (json.occurrencePattern != null) {
      result._patternTypeCase = 103;
      result._patternTypeValue = RewardPattern_OccurrencePattern.fromJson(json.occurrencePattern);
    }
    if (json.playerLevelPattern != null) {
      result._patternTypeCase = 104;
      result._patternTypeValue = RewardPattern_LevelDependentPattern.fromJson(json.playerLevelPattern);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasPatternName) {
      result.patternName = JsonToString.toJson(this._patternName);
    }
    if (this._items.length > 0) {
      result.items = ArrayToJson(this._items, RewardPattern_RewardPatternItem);
    }
    if (this._slots.length > 0) {
      result.slots = ArrayToJson(this._slots, RewardPattern_RewardPatternSlot);
    }
    switch (this._patternTypeCase) {
      case 101:
        result.regularPattern = RewardPattern_RegularPattern.toJson(this._patternTypeValue);
        break;
      case 102:
        result.dungeonPattern = RewardPattern_DungeonPattern.toJson(this._patternTypeValue);
        break;
      case 103:
        result.occurrencePattern = RewardPattern_OccurrencePattern.toJson(this._patternTypeValue);
        break;
      case 104:
        result.playerLevelPattern = RewardPattern_LevelDependentPattern.toJson(this._patternTypeValue);
        break;
      default:
        break;
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get patternName() {
    return this._hasPatternName ? this._patternName : JsonToString.default;
  }
  get hasPatternName() {
    return this._hasPatternName;
  }
  setPatternName(path, value) {
    return {type: 'SET', path: path.concat(['patternName']), value};
  }
  deletePatternName(path) {
    return {type: 'DELETE', path: path.concat(['patternName'])};
  }
  /**
   * @returns {RewardPattern_RewardPatternItem[]}
   */
  get items() {
    return this._items;
  }
  addItems(path, value) {
    return {type: 'ADD', path: path.concat(['items']), value: value.toJson()};
  }
  setItems(path, value) {
    return {type: 'SET', path: path.concat(['items']), value: ArrayToJson(value, RewardPattern_RewardPatternItem)};
  }
  setItemsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['items', key]), value: value.toJson()};
  }
  deleteItems(path) {
    return {type: 'DELETE', path: path.concat(['items'])};
  }
  deleteItemsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['items', key])};
  }
  /**
   * @returns {RewardPattern_RewardPatternSlot[]}
   */
  get slots() {
    return this._slots;
  }
  addSlots(path, value) {
    return {type: 'ADD', path: path.concat(['slots']), value: value.toJson()};
  }
  setSlots(path, value) {
    return {type: 'SET', path: path.concat(['slots']), value: ArrayToJson(value, RewardPattern_RewardPatternSlot)};
  }
  setSlotsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['slots', key]), value: value.toJson()};
  }
  deleteSlots(path) {
    return {type: 'DELETE', path: path.concat(['slots'])};
  }
  deleteSlotsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['slots', key])};
  }
  get patternTypeCase() {
    return this._patternTypeCase;
  }
  deletePatternType(path) {
    switch (this._patternTypeCase) {
      default:
      case 101: {
        return {type: 'DELETE', path: path.concat(['regularPattern'])};
      }
      case 102: {
        return {type: 'DELETE', path: path.concat(['dungeonPattern'])};
      }
      case 103: {
        return {type: 'DELETE', path: path.concat(['occurrencePattern'])};
      }
      case 104: {
        return {type: 'DELETE', path: path.concat(['playerLevelPattern'])};
      }
    }
  }
  /**
   * @returns {RewardPattern_RegularPattern}
   */
  get regularPattern() {
    return this._patternTypeCase === 101 ? this._patternTypeValue : RewardPattern_RegularPattern.default;
  }
  setRegularPattern(path, value) {
    return {type: 'SET', path: path.concat(['regularPattern']), value: value.toJson()};
  }
  deleteRegularPattern(path) {
    return {type: 'DELETE', path: path.concat(['regularPattern'])};
  }
  /**
   * @returns {RewardPattern_DungeonPattern}
   */
  get dungeonPattern() {
    return this._patternTypeCase === 102 ? this._patternTypeValue : RewardPattern_DungeonPattern.default;
  }
  setDungeonPattern(path, value) {
    return {type: 'SET', path: path.concat(['dungeonPattern']), value: value.toJson()};
  }
  deleteDungeonPattern(path) {
    return {type: 'DELETE', path: path.concat(['dungeonPattern'])};
  }
  /**
   * @returns {RewardPattern_OccurrencePattern}
   */
  get occurrencePattern() {
    return this._patternTypeCase === 103 ? this._patternTypeValue : RewardPattern_OccurrencePattern.default;
  }
  setOccurrencePattern(path, value) {
    return {type: 'SET', path: path.concat(['occurrencePattern']), value: value.toJson()};
  }
  deleteOccurrencePattern(path) {
    return {type: 'DELETE', path: path.concat(['occurrencePattern'])};
  }
  /**
   * @returns {RewardPattern_LevelDependentPattern}
   */
  get playerLevelPattern() {
    return this._patternTypeCase === 104 ? this._patternTypeValue : RewardPattern_LevelDependentPattern.default;
  }
  setPlayerLevelPattern(path, value) {
    return {type: 'SET', path: path.concat(['playerLevelPattern']), value: value.toJson()};
  }
  deletePlayerLevelPattern(path) {
    return {type: 'DELETE', path: path.concat(['playerLevelPattern'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "patternName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new RewardPattern(this);
              copy._hasPatternName = true;
              copy._patternName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPatternName) {
                return this;
              }
              const copy = new RewardPattern(this);
              copy._hasPatternName = false;
              copy._patternName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "items": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new RewardPattern(this);
              copy._items = [];        for (let i of value) {
                copy._items.push(RewardPattern_RewardPatternItem.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new RewardPattern(this);
              copy._items = copy._items.concat([RewardPattern_RewardPatternItem.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._items.length === 0) {
                return this;
              }
              const copy = new RewardPattern(this);
              copy._items = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._items.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new RewardPattern(this);
              copy._items = copy._items.slice();
              copy._items[path[1]] = RewardPattern_RewardPatternItem.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new RewardPattern(this);
              copy._items = copy._items.slice(0, path[1]).concat(copy._items.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._items.length) {
            return this;
          }
          const oldValue = this._items[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new RewardPattern(this);
          copy._items = copy._items.slice();
          copy._items[key] = newValue;
          return copy;
        }
      }
      case "slots": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new RewardPattern(this);
              copy._slots = [];        for (let i of value) {
                copy._slots.push(RewardPattern_RewardPatternSlot.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new RewardPattern(this);
              copy._slots = copy._slots.concat([RewardPattern_RewardPatternSlot.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._slots.length === 0) {
                return this;
              }
              const copy = new RewardPattern(this);
              copy._slots = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._slots.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new RewardPattern(this);
              copy._slots = copy._slots.slice();
              copy._slots[path[1]] = RewardPattern_RewardPatternSlot.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new RewardPattern(this);
              copy._slots = copy._slots.slice(0, path[1]).concat(copy._slots.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._slots.length) {
            return this;
          }
          const oldValue = this._slots[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new RewardPattern(this);
          copy._slots = copy._slots.slice();
          copy._slots[key] = newValue;
          return copy;
        }
      }
      case "regularPattern": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new RewardPattern(this);
              copy._patternTypeCase = 101;
              copy._patternTypeValue = RewardPattern_RegularPattern.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._patternTypeCase !== 101) {
                return this;
              }
              const copy = new RewardPattern(this);
              copy._patternTypeCase = 0;
              copy._patternTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._patternTypeCase !== 101) {
            const copy = new RewardPattern(this);
            copy._patternTypeCase = 101;
            copy._patternTypeValue = RewardPattern_RegularPattern.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.regularPattern.apply(type, path.slice(1), value);
          if (newValue === this.regularPattern) {
            return this;
          }
          const copy = new RewardPattern(this);
          copy._patternTypeCase = 101;
          copy._patternTypeValue = newValue;
          return copy;
        }
      }
      case "dungeonPattern": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new RewardPattern(this);
              copy._patternTypeCase = 102;
              copy._patternTypeValue = RewardPattern_DungeonPattern.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._patternTypeCase !== 102) {
                return this;
              }
              const copy = new RewardPattern(this);
              copy._patternTypeCase = 0;
              copy._patternTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._patternTypeCase !== 102) {
            const copy = new RewardPattern(this);
            copy._patternTypeCase = 102;
            copy._patternTypeValue = RewardPattern_DungeonPattern.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.dungeonPattern.apply(type, path.slice(1), value);
          if (newValue === this.dungeonPattern) {
            return this;
          }
          const copy = new RewardPattern(this);
          copy._patternTypeCase = 102;
          copy._patternTypeValue = newValue;
          return copy;
        }
      }
      case "occurrencePattern": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new RewardPattern(this);
              copy._patternTypeCase = 103;
              copy._patternTypeValue = RewardPattern_OccurrencePattern.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._patternTypeCase !== 103) {
                return this;
              }
              const copy = new RewardPattern(this);
              copy._patternTypeCase = 0;
              copy._patternTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._patternTypeCase !== 103) {
            const copy = new RewardPattern(this);
            copy._patternTypeCase = 103;
            copy._patternTypeValue = RewardPattern_OccurrencePattern.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.occurrencePattern.apply(type, path.slice(1), value);
          if (newValue === this.occurrencePattern) {
            return this;
          }
          const copy = new RewardPattern(this);
          copy._patternTypeCase = 103;
          copy._patternTypeValue = newValue;
          return copy;
        }
      }
      case "playerLevelPattern": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new RewardPattern(this);
              copy._patternTypeCase = 104;
              copy._patternTypeValue = RewardPattern_LevelDependentPattern.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._patternTypeCase !== 104) {
                return this;
              }
              const copy = new RewardPattern(this);
              copy._patternTypeCase = 0;
              copy._patternTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._patternTypeCase !== 104) {
            const copy = new RewardPattern(this);
            copy._patternTypeCase = 104;
            copy._patternTypeValue = RewardPattern_LevelDependentPattern.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.playerLevelPattern.apply(type, path.slice(1), value);
          if (newValue === this.playerLevelPattern) {
            return this;
          }
          const copy = new RewardPattern(this);
          copy._patternTypeCase = 104;
          copy._patternTypeValue = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {RewardPattern} other
   * @returns {RewardPattern}
   */
  merge(other) {
    const copy = new RewardPattern(this);
    if (other._hasPatternName) {
      copy._hasPatternName = true;
      copy._patternName = other._patternName;
    }
    copy._items = this._items.concat(other._items);
    copy._slots = this._slots.concat(other._slots);
    if (other._patternTypeCase === 101) {
      if (this._patternTypeCase === 101) {
        copy._patternTypeValue = copy._patternTypeValue.merge(other._patternTypeValue);
      } else {
        copy._patternTypeValue = other._patternTypeValue;
      }
      copy._patternTypeCase = 101;
    }
    if (other._patternTypeCase === 101) {
      if (this._patternTypeCase === 101) {
        copy._patternTypeValue = copy._patternTypeValue.merge(other._patternTypeValue);
      } else {
        copy._patternTypeValue = other._patternTypeValue;
      }
      copy._patternTypeCase = 101;
    }
    if (other._patternTypeCase === 101) {
      if (this._patternTypeCase === 101) {
        copy._patternTypeValue = copy._patternTypeValue.merge(other._patternTypeValue);
      } else {
        copy._patternTypeValue = other._patternTypeValue;
      }
      copy._patternTypeCase = 101;
    }
    if (other._patternTypeCase === 101) {
      if (this._patternTypeCase === 101) {
        copy._patternTypeValue = copy._patternTypeValue.merge(other._patternTypeValue);
      } else {
        copy._patternTypeValue = other._patternTypeValue;
      }
      copy._patternTypeCase = 101;
    }
    return copy;
  }
}
RewardPattern.default = new RewardPattern();
RewardPattern.RewardPatternItem = RewardPattern_RewardPatternItem;
RewardPattern.RewardPatternSlot = RewardPattern_RewardPatternSlot;
RewardPattern.RegularPattern = RewardPattern_RegularPattern;
RewardPattern.DungeonPattern = RewardPattern_DungeonPattern;
RewardPattern.OccurrencePattern = RewardPattern_OccurrencePattern;
RewardPattern.LevelDependentPattern = RewardPattern_LevelDependentPattern;
class RewardPattern_Builder {
  constructor(value) {
    this._value = new RewardPattern(value);
  }
  build() {
    return new RewardPattern(this._value);
  }
  setPatternName(value) {
    this._value._hasPatternName = true;
    this._value._patternName = value;
    return this;
  }
  deletePatternName() {
    this._value._hasPatternName = false;
    this._value._patternName = null;
    return this;
  }
  addAllItems(values) {
    this._value._items = this._value._items.concat(values);
    return this;
  }
  addItems(value) {
    this._value._items = this._value._items.concat([value]);
    return this;
  }
  setItems(index, value) {
    this._value._items = this._value._items.concat();
    this._value._items[index] = value;
    return this;
  }
  clearItems() {
    this._value._items = [];
    return this;
  }
  addAllSlots(values) {
    this._value._slots = this._value._slots.concat(values);
    return this;
  }
  addSlots(value) {
    this._value._slots = this._value._slots.concat([value]);
    return this;
  }
  setSlots(index, value) {
    this._value._slots = this._value._slots.concat();
    this._value._slots[index] = value;
    return this;
  }
  clearSlots() {
    this._value._slots = [];
    return this;
  }
  clearpatternType() {
    this._value._patternTypeCase = 0;
    this._value._patternTypeValue = null;
    return this;
  }
  setRegularPattern(value) {
    this._value._patternTypeCase = 101;
    this._value._patternTypeValue = value;
    return this;
  }
  setDungeonPattern(value) {
    this._value._patternTypeCase = 102;
    this._value._patternTypeValue = value;
    return this;
  }
  setOccurrencePattern(value) {
    this._value._patternTypeCase = 103;
    this._value._patternTypeValue = value;
    return this;
  }
  setPlayerLevelPattern(value) {
    this._value._patternTypeCase = 104;
    this._value._patternTypeValue = value;
    return this;
  }
}
RewardPattern.Builder = RewardPattern_Builder;
class RewardPattern_WithParent {
  /**
   * @param {RewardPattern} value
   * @param {RewardPattern_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return RewardPattern.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasPatternName() {
    if (this._cachedHasPatternName === undefined) {
      if (this._value.hasPatternName) {
        this._cachedHasPatternName = true;
      } else {
        this._cachedHasPatternName = this._parent ? this._parent.hasPatternName : false;
      }
    }
    return this._cachedHasPatternName;
  }
  get patternName() {
    if (this._cachedPatternName === undefined) {
      if (this._value.hasPatternName) {
        this._cachedPatternName = this._value.patternName;
      } else {
        this._cachedPatternName = this._parent ? this._parent.patternName : this._value.patternName;
      }
    }
    return this._cachedPatternName;
  }
  get selfItems() {
    if (!this._selfItems) {
      this._selfItems = [];
      for (let i of this._value.items) {
        this._selfItems.push(new RewardPattern_RewardPatternItem.WithParent(i, null));
      }
    }
    return this._selfItems;
  }
  get inherentItems() {
    if (!this._inherentItems) {
      this._inherentItems = this._parent ? this._parent.items : [];
    }
    return this._inherentItems;
  }
  get items() {
    if (!this._allItems) {
      this._allItems = this._parent ? this._parent.items.concat(this.selfItems) : this.selfItems;
    }
    return this._allItems;
  }
  get selfSlots() {
    if (!this._selfSlots) {
      this._selfSlots = [];
      for (let i of this._value.slots) {
        this._selfSlots.push(new RewardPattern_RewardPatternSlot.WithParent(i, null));
      }
    }
    return this._selfSlots;
  }
  get inherentSlots() {
    if (!this._inherentSlots) {
      this._inherentSlots = this._parent ? this._parent.slots : [];
    }
    return this._inherentSlots;
  }
  get slots() {
    if (!this._allSlots) {
      this._allSlots = this._parent ? this._parent.slots.concat(this.selfSlots) : this.selfSlots;
    }
    return this._allSlots;
  }
  get patternTypeCase() {
    if (this._cachedpatternTypeCase === undefined) {
      if (this._value._patternTypeCase === 0) {
        this._cachedpatternTypeCase = this._parent ? this._parent.patternTypeCase : 0;
      } else {
        this._cachedpatternTypeCase = this._value._patternTypeCase;
      }
    }
    return this._cachedpatternTypeCase;
  }
  get regularPattern() {
    if (!this._cachedRegularPattern) {
      if (this._value._patternTypeCase === 0) {
        this._cachedRegularPattern = this._parent ? new RewardPattern_RegularPattern.WithParent(RewardPattern_RegularPattern.default, this._parent.regularPattern) : this._value.regularPattern;
      } else if (this._value._patternTypeCase === 101) {
        this._cachedRegularPattern = new RewardPattern_RegularPattern.WithParent(this._value.regularPattern, this._parent && this._parent.patternTypeCase === 101 ? this._parent.regularPattern : null);
      } else {
        this._cachedRegularPattern = RewardPattern_RegularPattern.WithParent.default;
      }
    }
    return this._cachedRegularPattern;
  }
  get dungeonPattern() {
    if (!this._cachedDungeonPattern) {
      if (this._value._patternTypeCase === 0) {
        this._cachedDungeonPattern = this._parent ? new RewardPattern_DungeonPattern.WithParent(RewardPattern_DungeonPattern.default, this._parent.dungeonPattern) : this._value.dungeonPattern;
      } else if (this._value._patternTypeCase === 102) {
        this._cachedDungeonPattern = new RewardPattern_DungeonPattern.WithParent(this._value.dungeonPattern, this._parent && this._parent.patternTypeCase === 102 ? this._parent.dungeonPattern : null);
      } else {
        this._cachedDungeonPattern = RewardPattern_DungeonPattern.WithParent.default;
      }
    }
    return this._cachedDungeonPattern;
  }
  get occurrencePattern() {
    if (!this._cachedOccurrencePattern) {
      if (this._value._patternTypeCase === 0) {
        this._cachedOccurrencePattern = this._parent ? new RewardPattern_OccurrencePattern.WithParent(RewardPattern_OccurrencePattern.default, this._parent.occurrencePattern) : this._value.occurrencePattern;
      } else if (this._value._patternTypeCase === 103) {
        this._cachedOccurrencePattern = new RewardPattern_OccurrencePattern.WithParent(this._value.occurrencePattern, this._parent && this._parent.patternTypeCase === 103 ? this._parent.occurrencePattern : null);
      } else {
        this._cachedOccurrencePattern = RewardPattern_OccurrencePattern.WithParent.default;
      }
    }
    return this._cachedOccurrencePattern;
  }
  get playerLevelPattern() {
    if (!this._cachedPlayerLevelPattern) {
      if (this._value._patternTypeCase === 0) {
        this._cachedPlayerLevelPattern = this._parent ? new RewardPattern_LevelDependentPattern.WithParent(RewardPattern_LevelDependentPattern.default, this._parent.playerLevelPattern) : this._value.playerLevelPattern;
      } else if (this._value._patternTypeCase === 104) {
        this._cachedPlayerLevelPattern = new RewardPattern_LevelDependentPattern.WithParent(this._value.playerLevelPattern, this._parent && this._parent.patternTypeCase === 104 ? this._parent.playerLevelPattern : null);
      } else {
        this._cachedPlayerLevelPattern = RewardPattern_LevelDependentPattern.WithParent.default;
      }
    }
    return this._cachedPlayerLevelPattern;
  }
  update(current, parent) {
    const result = new RewardPattern_WithParent(current, parent);
    if (this._selfItems) {
      if (this._value.items === current.items) {
        result._selfItems = this._selfItems;
      } else {
        result._selfItems = [];
        for (let i = 0; i < current.items.length; i++) {
          const oldValue = this._value.items[i];
          if (oldValue) {
            const oldCache = this._selfItems[i];
            if (oldValue === current.items[i]) {
              result._selfItems[i] = oldCache;
            } else {
              result._selfItems[i] = oldCache.update(current.items[i], null);
            }
          } else {
            result._selfItems[i] = new RewardPattern_RewardPatternItem.WithParent(current.items[i], null);
          }
        }
      }
    }
    if (this._selfSlots) {
      if (this._value.slots === current.slots) {
        result._selfSlots = this._selfSlots;
      } else {
        result._selfSlots = [];
        for (let i = 0; i < current.slots.length; i++) {
          const oldValue = this._value.slots[i];
          if (oldValue) {
            const oldCache = this._selfSlots[i];
            if (oldValue === current.slots[i]) {
              result._selfSlots[i] = oldCache;
            } else {
              result._selfSlots[i] = oldCache.update(current.slots[i], null);
            }
          } else {
            result._selfSlots[i] = new RewardPattern_RewardPatternSlot.WithParent(current.slots[i], null);
          }
        }
      }
    }
    if (this._cachedRegularPattern && this._value._patternTypeCase === 101 && current._patternTypeCase === 101) {
      if (this._value.regularPattern === current.regularPattern && this._parent === parent) {
        result._cachedRegularPattern = this._cachedRegularPattern;
      } else {
        result._cachedRegularPattern = this._cachedRegularPattern.update(current.regularPattern, parent && parent.patternTypeCase === 101 ? parent.regularPattern : null);
      }
    }
    if (this._cachedDungeonPattern && this._value._patternTypeCase === 102 && current._patternTypeCase === 102) {
      if (this._value.dungeonPattern === current.dungeonPattern && this._parent === parent) {
        result._cachedDungeonPattern = this._cachedDungeonPattern;
      } else {
        result._cachedDungeonPattern = this._cachedDungeonPattern.update(current.dungeonPattern, parent && parent.patternTypeCase === 102 ? parent.dungeonPattern : null);
      }
    }
    if (this._cachedOccurrencePattern && this._value._patternTypeCase === 103 && current._patternTypeCase === 103) {
      if (this._value.occurrencePattern === current.occurrencePattern && this._parent === parent) {
        result._cachedOccurrencePattern = this._cachedOccurrencePattern;
      } else {
        result._cachedOccurrencePattern = this._cachedOccurrencePattern.update(current.occurrencePattern, parent && parent.patternTypeCase === 103 ? parent.occurrencePattern : null);
      }
    }
    if (this._cachedPlayerLevelPattern && this._value._patternTypeCase === 104 && current._patternTypeCase === 104) {
      if (this._value.playerLevelPattern === current.playerLevelPattern && this._parent === parent) {
        result._cachedPlayerLevelPattern = this._cachedPlayerLevelPattern;
      } else {
        result._cachedPlayerLevelPattern = this._cachedPlayerLevelPattern.update(current.playerLevelPattern, parent && parent.patternTypeCase === 104 ? parent.playerLevelPattern : null);
      }
    }
    return result;
  }
}
RewardPattern_WithParent.default = new RewardPattern_WithParent(RewardPattern.default, null);
RewardPattern.WithParent = RewardPattern_WithParent;
class RewardPattern_Descriptor {
  get patternName() {
    if (!this._patternName) {
      this._patternName = {
        name: "patternName",
        Name: "PatternName",
        number: 1,
        protoType: 9,
        protoName: "pattern_name",
        type: JsonToString,
        options: {
          comments: "This MUST be unique among all patterns",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._patternName;
  }
  get items() {
    if (!this._items) {
      this._items = {
        name: "items",
        Name: "Items",
        number: 2,
        protoType: 11,
        protoName: "items",
        type: RewardPattern_RewardPatternItem,
        isRepeated: true,
        options: {
          comments: "This means the chance field will roll on its own for all items",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._items;
  }
  get slots() {
    if (!this._slots) {
      this._slots = {
        name: "slots",
        Name: "Slots",
        number: 3,
        protoType: 11,
        protoName: "slots",
        type: RewardPattern_RewardPatternSlot,
        isRepeated: true,
        options: {
          comments: "Each slot will guarantee to drop exactly 1 item among all items in that slot",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._slots;
  }
  get regularPattern() {
    if (!this._regularPattern) {
      this._regularPattern = {
        name: "regularPattern",
        Name: "RegularPattern",
        number: 101,
        protoType: 11,
        protoName: "regular_pattern",
        oneofIndex: 1,
        type: RewardPattern_RegularPattern,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._regularPattern;
  }
  get dungeonPattern() {
    if (!this._dungeonPattern) {
      this._dungeonPattern = {
        name: "dungeonPattern",
        Name: "DungeonPattern",
        number: 102,
        protoType: 11,
        protoName: "dungeon_pattern",
        oneofIndex: 1,
        type: RewardPattern_DungeonPattern,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._dungeonPattern;
  }
  get occurrencePattern() {
    if (!this._occurrencePattern) {
      this._occurrencePattern = {
        name: "occurrencePattern",
        Name: "OccurrencePattern",
        number: 103,
        protoType: 11,
        protoName: "occurrence_pattern",
        oneofIndex: 1,
        type: RewardPattern_OccurrencePattern,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._occurrencePattern;
  }
  get playerLevelPattern() {
    if (!this._playerLevelPattern) {
      this._playerLevelPattern = {
        name: "playerLevelPattern",
        Name: "PlayerLevelPattern",
        number: 104,
        protoType: 11,
        protoName: "player_level_pattern",
        oneofIndex: 1,
        type: RewardPattern_LevelDependentPattern,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._playerLevelPattern;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.patternName,
        this.items,
        this.slots,
        this.regularPattern,
        this.dungeonPattern,
        this.occurrencePattern,
        this.playerLevelPattern,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForPatternName",
        Name: "DummyOneofForPatternName",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "patternType",
        Name: "PatternType",
        fields: [
          this.fields[3],
          this.fields[4],
          this.fields[5],
          this.fields[6],
        ],
      });
    }
    return this._oneofs;
  }
}
RewardPattern.descriptor = new RewardPattern_Descriptor();
export class RewardPatternData {
  get descriptor() {
    return RewardPatternData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._rewardPatterns = [];
  }
  isEmpty() {
    if (this._rewardPatterns.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof RewardPatternData) {
      return value;
    }
    return RewardPatternData.fromJson(value);
  }
  static fromJson(json) {
    const result = new RewardPatternData();
    result._rewardPatterns = JsonToList(json.rewardPatterns, RewardPattern);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._rewardPatterns.length > 0) {
      result.rewardPatterns = ArrayToJson(this._rewardPatterns, RewardPattern);
    }
    return result;
  }
  /**
   * @returns {RewardPattern[]}
   */
  get rewardPatterns() {
    return this._rewardPatterns;
  }
  addRewardPatterns(path, value) {
    return {type: 'ADD', path: path.concat(['rewardPatterns']), value: value.toJson()};
  }
  setRewardPatterns(path, value) {
    return {type: 'SET', path: path.concat(['rewardPatterns']), value: ArrayToJson(value, RewardPattern)};
  }
  setRewardPatternsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['rewardPatterns', key]), value: value.toJson()};
  }
  deleteRewardPatterns(path) {
    return {type: 'DELETE', path: path.concat(['rewardPatterns'])};
  }
  deleteRewardPatternsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['rewardPatterns', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "rewardPatterns": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new RewardPatternData(this);
              copy._rewardPatterns = [];        for (let i of value) {
                copy._rewardPatterns.push(RewardPattern.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new RewardPatternData(this);
              copy._rewardPatterns = copy._rewardPatterns.concat([RewardPattern.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._rewardPatterns.length === 0) {
                return this;
              }
              const copy = new RewardPatternData(this);
              copy._rewardPatterns = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._rewardPatterns.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new RewardPatternData(this);
              copy._rewardPatterns = copy._rewardPatterns.slice();
              copy._rewardPatterns[path[1]] = RewardPattern.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new RewardPatternData(this);
              copy._rewardPatterns = copy._rewardPatterns.slice(0, path[1]).concat(copy._rewardPatterns.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._rewardPatterns.length) {
            return this;
          }
          const oldValue = this._rewardPatterns[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new RewardPatternData(this);
          copy._rewardPatterns = copy._rewardPatterns.slice();
          copy._rewardPatterns[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {RewardPatternData} other
   * @returns {RewardPatternData}
   */
  merge(other) {
    const copy = new RewardPatternData(this);
    copy._rewardPatterns = this._rewardPatterns.concat(other._rewardPatterns);
    return copy;
  }
}
RewardPatternData.default = new RewardPatternData();
class RewardPatternData_Builder {
  constructor(value) {
    this._value = new RewardPatternData(value);
  }
  build() {
    return new RewardPatternData(this._value);
  }
  addAllRewardPatterns(values) {
    this._value._rewardPatterns = this._value._rewardPatterns.concat(values);
    return this;
  }
  addRewardPatterns(value) {
    this._value._rewardPatterns = this._value._rewardPatterns.concat([value]);
    return this;
  }
  setRewardPatterns(index, value) {
    this._value._rewardPatterns = this._value._rewardPatterns.concat();
    this._value._rewardPatterns[index] = value;
    return this;
  }
  clearRewardPatterns() {
    this._value._rewardPatterns = [];
    return this;
  }
}
RewardPatternData.Builder = RewardPatternData_Builder;
class RewardPatternData_WithParent {
  /**
   * @param {RewardPatternData} value
   * @param {RewardPatternData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return RewardPatternData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfRewardPatterns() {
    if (!this._selfRewardPatterns) {
      this._selfRewardPatterns = [];
      for (let i of this._value.rewardPatterns) {
        this._selfRewardPatterns.push(new RewardPattern.WithParent(i, null));
      }
    }
    return this._selfRewardPatterns;
  }
  get inherentRewardPatterns() {
    if (!this._inherentRewardPatterns) {
      this._inherentRewardPatterns = this._parent ? this._parent.rewardPatterns : [];
    }
    return this._inherentRewardPatterns;
  }
  get rewardPatterns() {
    if (!this._allRewardPatterns) {
      this._allRewardPatterns = this._parent ? this._parent.rewardPatterns.concat(this.selfRewardPatterns) : this.selfRewardPatterns;
    }
    return this._allRewardPatterns;
  }
  update(current, parent) {
    const result = new RewardPatternData_WithParent(current, parent);
    if (this._selfRewardPatterns) {
      if (this._value.rewardPatterns === current.rewardPatterns) {
        result._selfRewardPatterns = this._selfRewardPatterns;
      } else {
        result._selfRewardPatterns = [];
        for (let i = 0; i < current.rewardPatterns.length; i++) {
          const oldValue = this._value.rewardPatterns[i];
          if (oldValue) {
            const oldCache = this._selfRewardPatterns[i];
            if (oldValue === current.rewardPatterns[i]) {
              result._selfRewardPatterns[i] = oldCache;
            } else {
              result._selfRewardPatterns[i] = oldCache.update(current.rewardPatterns[i], null);
            }
          } else {
            result._selfRewardPatterns[i] = new RewardPattern.WithParent(current.rewardPatterns[i], null);
          }
        }
      }
    }
    return result;
  }
}
RewardPatternData_WithParent.default = new RewardPatternData_WithParent(RewardPatternData.default, null);
RewardPatternData.WithParent = RewardPatternData_WithParent;
class RewardPatternData_Descriptor {
  get rewardPatterns() {
    if (!this._rewardPatterns) {
      this._rewardPatterns = {
        name: "rewardPatterns",
        Name: "RewardPatterns",
        number: 1,
        protoType: 11,
        protoName: "reward_patterns",
        type: RewardPattern,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._rewardPatterns;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.rewardPatterns,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
RewardPatternData.descriptor = new RewardPatternData_Descriptor();
